var e = function(r) {
  for (var n = Array(r.length), t = 0; t < r.length; ++t)
    n[t] = r[t];
  return n;
}, a = function(r) {
  return Array.isArray(r) ? r : [r];
}, y = function(r) {
  return Array.isArray(r) ? r[0] : r;
};
export {
  a as asArray,
  y as getFirst,
  e as toArray
};
